<template>
  <div :id="content ? content.idHTML : ''" :class="jel_getClassObject(content)">
    <h1 v-if="titreMessage && isAvertissement" class="grandTitre text-left">
      {{ jel_replaceTokens(titreMessage) }}
    </h1>
    <div v-if="show" class="d-inline-flex">
      <div v-if="isErreur" class="cercleErreur">
        <span class="cercleErreur-contenu">!</span>
      </div>
      <div class="d-flex" :class="isAvertissement ? 'mt-1 mb-3' : 'ml-1 mb-2'">
        <span
          :class="isAvertissement ? 'Paragraphe' : 'message-erreur'"
          v-html="jel_replaceTokens(message.msgDetail)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main';

import MessageHelpers from '@/helpers/MessageHelpers';

export default {
  name: 'Message',
  props: {
    content: { type: Object, required: false },
  },
  data() {
    return {
      message: null,
    };
  },

  computed: {
    show() {
      return !!this.message;
    },
    isErreur() {
      return this.message && this.message.msgType === 'erreur';
    },
    isAvertissement() {
      return this.message && this.message.msgType === 'avertissement';
    },
    titreMessage() {
      if (this.message && this.message.msgTitre) {
        return this.message.msgTitre;
      }
      return '';
    },
  },
  async mounted() {
    const self = this;

    bus.$on('afficherMessage', (msg) => {
      self.message = msg;
      const self2 = self;
      if (!msg) {
        this.clearFlash();
      }
      this.getMessage(msg).then((result) => {
        self2.message = result;
        // Se positionner tout en haut pour s'assurer que le message est visible
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });
    });
  },
  beforeDestroy() {
    bus.$off('afficherMessage');
  },
  methods: {
    getter(name) {
      return `message/${name}`;
    },

    // 3 possibilités:
    // 1. obj=(string, Ex: MSG04), on récupère le message
    // 2. obj={msgCode:val,msgDetail:val,msgTitre:val,msgType:val}, message tel quel
    // 3. obj=null, on tente de prendre le message dans le store
    async getMessage(obj) {
      let ret = null;

      if (!obj) {
        obj = this.getFlash();
        this.clearFlash();
      }

      if (obj) {
        if (typeof obj == 'string') {
          ret = await MessageHelpers.obtenirMessage(obj, this.$root);
        } else {
          ret = obj;
        }
      }
      return ret;
    },
    getFlash() {
      // TODO: Besoin futur gérer plusieurs messages
      return this.$store.getters[this.getter('getMessagesFlash')][0];
    },
    clearFlash() {
      this.$store.commit('message/RESET_LISTE_MESSAGES_FLASH');
    },
  },
};
</script>
